import { Component, HostBinding, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Product } from '@queries/generated';

@Component({
  selector: 'vnm-product-bundle',
  templateUrl: './product-bundle.component.html',
  styleUrls: ['./product-bundle.component.scss']
})
export class ProductBundleComponent implements OnChanges {
  @HostBinding('class') get classAttr() {
    return this.products?.length ? 'flex flex-wrap gap-xxs align-items-center' : 'hidden';
  }

  @Input() products: Product[];
  @Input() icon = 'box-open';

  productList = '';

  ngOnChanges(changes: SimpleChanges) {
    if (changes.products) {
      this.productList = this.products?.map(({ name }) => name).join(', ');
    }
  }
}
